
// Utility logger that only logs messages in development mode
//  src/utils/logger.js

/**
 * Logger personnalisé pour gérer les logs selon l'environnement
 * 
 * En développement : tous les logs sont affichés dans la console
 * En production : seules les erreurs sont affichées (pour le débogage critique)
 * 
 * Cela évite d'exposer des informations sensibles en production
 * et améliore légèrement les performances
 */

// import logger from './logger';

// // Logs qui disparaîtront en production
// logger.log('Requête authentifiée');
// logger.info('Utilisateur connecté:', userId);
// logger.warn('Tentative de reconnexion...');

// // Erreurs qui resteront visibles en production
// logger.error('Échec de l\'authentification:', error);

const logger = {
  /**
   * Log d'information générale
   * Visible uniquement en développement
   * @param {...any} args - Arguments à logger (comme console.log)
   */
  log: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
    // En production : rien ne s'affiche
  },

  /**
   * Log d'information (niveau info)
   * Visible uniquement en développement
   * @param {...any} args - Arguments à logger
   */
  info: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
    // En production : rien ne s'affiche
  },

  /**
   * Log d'avertissement
   * Visible uniquement en développement
   * @param {...any} args - Arguments à logger
   */
  warn: (...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
    // En production : rien ne s'affiche
  },

  /**
   * Log d'erreur
   * TOUJOURS VISIBLE (même en production)
   * Utilisez cette méthode uniquement pour les erreurs critiques
   * qui nécessitent un débogage même en production
   * @param {...any} args - Arguments à logger
   */
  error: (...args) => {
    console.error(...args);
    // Reste visible en production pour diagnostiquer les bugs critiques
  }
};

// Exporte le logger pour l'utiliser partout dans l'application
export default logger;